export function getPastelTheme(baseHex) {
    function hexToRgb(hex) {
        hex = hex.replace('#', '');
        if (hex.length === 3) {
            hex = hex.split('').map((x)=>x + x).join('');
        }
        return {
            r: parseInt(hex.substring(0, 2), 16),
            g: parseInt(hex.substring(2, 4), 16),
            b: parseInt(hex.substring(4, 6), 16)
        };
    }
    function rgbToHex({ r, g, b }) {
        const toHex = (v)=>Math.round(v).toString(16).padStart(2, '0');
        return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
    }
    function rgbToHexA({ r, g, b, a }) {
        const toHex = (v)=>Math.round(v).toString(16).padStart(2, '0');
        return `#${toHex(r)}${toHex(g)}${toHex(b)}${a !== undefined ? toHex(a * 255) : ''}`;
    }
    function rgbToHsl({ r, g, b }) {
        r /= 255;
        g /= 255;
        b /= 255;
        const max = Math.max(r, g, b);
        const min = Math.min(r, g, b);
        const l = (max + min) / 2;
        const d = max - min;
        let h = 0;
        let s = 0;
        if (d !== 0) {
            s = d / (1 - Math.abs(2 * l - 1));
            switch(max){
                case r:
                    h = (g - b) / d % 6;
                    break;
                case g:
                    h = (b - r) / d + 2;
                    break;
                case b:
                    h = (r - g) / d + 4;
                    break;
                default:
                    break;
            }
            h *= 60;
            if (h < 0) {
                h += 360;
            }
        }
        return {
            h,
            s,
            l
        };
    }
    function hslToRgb({ h, s, l }) {
        const c = (1 - Math.abs(2 * l - 1)) * s;
        const x = c * (1 - Math.abs(h / 60 % 2 - 1));
        const m = l - c / 2;
        let r = 0;
        let g = 0;
        let b = 0;
        if (h < 60) {
            [r, g, b] = [
                c,
                x,
                0
            ];
        } else if (h < 120) {
            [r, g, b] = [
                x,
                c,
                0
            ];
        } else if (h < 180) {
            [r, g, b] = [
                0,
                c,
                x
            ];
        } else if (h < 240) {
            [r, g, b] = [
                0,
                x,
                c
            ];
        } else if (h < 300) {
            [r, g, b] = [
                x,
                0,
                c
            ];
        } else {
            [r, g, b] = [
                c,
                0,
                x
            ];
        }
        return {
            r: (r + m) * 255,
            g: (g + m) * 255,
            b: (b + m) * 255
        };
    }
    const baseRgb = hexToRgb(baseHex);
    const baseHsl = rgbToHsl(baseRgb);
    // 🌸 Pastel background
    const bgHsl = {
        h: baseHsl.h,
        s: baseHsl.s,
        l: 0.95
    };
    const sidebarHsl = {
        h: baseHsl.h,
        s: baseHsl.s,
        l: 0.85
    };
    const iconColor = {
        h: baseHsl.h,
        s: baseHsl.s,
        l: 0.15
    };
    const bgRgb = hslToRgb(bgHsl);
    const sidebarRgb = hslToRgb(sidebarHsl);
    const iconColorRgb = hslToRgb(iconColor);
    return {
        background: `linear-gradient(90deg, ${rgbToHex(bgRgb)} 0%, ${rgbToHexA({
            ...bgRgb,
            a: 0.1
        })} 20%, #E8E8E8 100%)`,
        menuColor: rgbToHex(iconColorRgb),
        backgroundMenuColor: rgbToHex(sidebarRgb),
        navBg: rgbToHex(bgRgb)
    };
}
export function applyPastelTheme(baseHex) {
    const theme = getPastelTheme(baseHex);
    document.documentElement.style.setProperty('--nav-bg', theme.navBg);
    document.documentElement.style.setProperty('--page-background', theme.background);
    document.documentElement.style.setProperty('--primary-menu-color', theme.menuColor);
    document.documentElement.style.setProperty('--selected-menu-bg', theme.backgroundMenuColor);
}
